<template>
  <div :class="$style.component">
    <p class="viewSubtitle">
      {{t('infoTabSmallText')}}
    </p>
    <div class="viewTitle">
      <img v-if="currentLanguage === 'fi'" src="../../assets/images/howto-fi.svg" />
      <img v-if="currentLanguage === 'sv'" src="../../assets/images/howto-sv.svg" />
      <img v-if="currentLanguage === 'en'" src="../../assets/images/howto-en.svg" />
    </div>
    <div :class="$style.content">
      <span v-html="t('infoTabHtmlContent')"></span>
    </div>
  </div>
</template>

<script>
import {inject} from '@vue/composition-api'
import useTranslations from '@/composition/useTranslations'

export default {
  setup () {
    return {
      currentLanguage: inject('currentLanguage').value,
      t: useTranslations(),
    }
  },
}
</script>

<style module lang="scss">
.component {
  display: flex;
  flex-direction: column;
}

.content {
  position: relative;
  z-index: 1;
  padding: variables.$spacing-20;
  max-width: 670px;
  margin-inline: auto;
}
</style>
